import * as React from "react";
import styled from "styled-components";

interface IProps {
  className?: string;
  onClose(): void;
}

const View = ({ className, onClose }: IProps) => {
  return (
    <i className={className} onClick={onClose}>
      <svg width="36" height="36" viewBox="0 0 24 24">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </i>
  );
};

export const CloseButton = styled(View)`
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  padding: 0.3em;
  z-index: 3;
  svg {
    fill: rgba(255, 255, 255, 0.4);
    vertical-align: middle;
  }
  &:hover {
    svg {
      fill: rgba(255, 255, 255, 1);
    }
  }
`;
